import React from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import styled from 'styled-components'

import { DropdownField, ListInputField } from 'components/fields'

const TaskInputContainer = styled.div`
  border: 1px solid #ccc;
  margin-bottom: 16px;
`

const InputAndFrequency = styled.div`
  display: flex;
  flex-direction: row;
`

const Tasks = ({
  fields,
  frequencies,
  handleKeyDown,
  getValues,
  isNewJob,
  setIsNewToFalse,
  serviceFrequency
}) => {

  const addTask = () => {
    const values = getValues()

    const someEmptyTask = values.tasks.some(task => !task || !task.name)

    if (!someEmptyTask) {
      setIsNewToFalse()
      if (serviceFrequency) {
        fields.push({ frequency: serviceFrequency })
      } else {
        fields.push({})
      }
    }
  }

  const _handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      addTask()
    }
  }

  const _handleDeleteTask = index => {
    fields.remove(index)
  }

  const _handleAddTask = () => {
    addTask()
  }

  return (
    <TaskInputContainer>
      {fields.map((task, index) => (
        <InputAndFrequency key={index} id="taskContainer">
          <Field
            name={`${task}.name`}
            component={ListInputField}
            handleKeyDown={_handleKeyDown}
            onAddTask={() => _handleAddTask()}
            onDeleteTask={() => _handleDeleteTask(index)}
            type="text"
            isNewJob={isNewJob}
            placeholder="Press Enter to save"
            fieldsLength={fields.length}
          />
          {!!frequencies && (
            <div style={{ width: 150 }}>
              <Field
                name={`${task}.frequency`}
                component={DropdownField}
                data={frequencies}
                filter={false}
                type="select"
                isInsideTaskInput={true}
              />
            </div>
          )}
        </InputAndFrequency>
      ))}
    </TaskInputContainer>
  )
}

const TasksForm = ({
  frequencies,
  handleKeyDown,
  getValues,
  isNewJob,
  serviceFrequency,
  setIsNewToFalse
}) => {
  return (
    <FieldArray
      name="tasks"
      component={Tasks}
      handleKeyDown={handleKeyDown}
      getValues={getValues}
      isNewJob={isNewJob}
      setIsNewToFalse={setIsNewToFalse}
      frequencies={frequencies}
      serviceFrequency={serviceFrequency}
    />
  )
}

export default reduxForm({
  form: 'Tasks'
})(TasksForm)
